/*
 *   File : index.js
 *   Author URI : https://evoqins.com
 *   Description : Index file to import functions
 *   Integrations : 
 *   Version : v1.1
*/

import { combineReducers } from "redux";
import Reducer from "./reducer";

export const rootReducer = combineReducers({
    Reducer
})